import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import history from "../../auth/history";
import './SenderData.css';
import Avatar from 'react-avatar';
import { Link } from "react-router-dom";

import { store } from "../../redux/store";
import { selectedBeneList, setBenefisciaryList } from "../../redux/misc-data/misc-data.action";
import { setSendersListDetails, selectedSender } from './../../redux/misc-data/misc-data.action';
const httpClient = axios.create();
class SenderData extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			errorMessage: ''
		}
	}

	componentDidMount() {
		this.setState({
			errorMessage: ''
		})
	}
	componentWillUnmount() {
	}




	sender = (event, mobileNo) => {

		event.preventDefault();
		this.setState({
			errorMessage: ''
		})
		// store.dispatch(setSendersListDetails(''));

		var allsenderuRL = '/api/v1/dmt/customer/details/' + mobileNo;
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		httpClient.get(allsenderuRL, { headers }
		).then((response) => {
			console.log('selected sender response' + JSON.stringify(response.data));
			console.log(response.data.response.msg);
			if (response.data.response.msg == 'SUCCESS') {

				store.dispatch(selectedSender(response.data));
				store.dispatch(selectedBeneList(response.data.customer.beneficiaries));

				var gotoSenderPage = document.getElementById('gotoSenderPage');
				gotoSenderPage.click();
			} else {
				this.errorMessageCall(response.data.response.displayMsg);
			}
		}).catch(error => {

			this.errorMessageCall(error);
		});
	}


	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error.message
		})
	}

	render() {
		return (

			<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
				<Link to='/sender'>
					<button id='gotoSenderPage' hidden={true}></button>
				</Link>
				<div class="sendercard" onClick={e => this.sender(e, this.props.mobile)}>
					<Avatar name={this.props.name} round={true} size="44" />
					<h5>{this.props.name}</h5>
					<p>{this.props.mobile}</p>
					<button type="button" class="fav"><i class="fstar"></i></button>
				</div>
				{this.state.errorMessage != '' &&
					<div class='valid-error'>
						{this.state.errorMessage}
					</div>
				}
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, agentInfo, token ,clientRole} }
) => ({
	errorMessage, loginErrorMessage, phone, agentInfo, token,clientRole
});

export default connect(mapStateToProps, null)(SenderData);
